import Car from "./car.vue";
export default Car;
export type CarInstance = InstanceType<typeof Car>;
